import classNames from 'classnames'
import React from 'react'

import Header from '../culdesacTempe3/Header'
import Footer from './Footer'

interface LayoutProps {
  children?: React.ReactNode
  className?: string
  showFooter?: boolean
}

/**
 * The site layout for pages on Culdesac's main site.
 * @returns JSX to render the site layout w/ children contained within.
 */
const Layout: React.FC<LayoutProps> = ({children, className, showFooter = true}) => (
  <span className={classNames('new-design', className)}>
    <section className="relative px-2 py-4 text-white bg-[#5AA9A7] md:py-0 md:px-0">
      <div className="relative z-10 mx-auto">
        <Header isHero={false} />
      </div>
    </section>
    {children}
    {showFooter && <Footer />}
  </span>
)

export default Layout
